module.exports = __webpack_public_path__ + "img/e_3_23_r.2f63adfe.png";